export default "__VITE_ASSET__f5a9be38__"